import { PropsWithChildren, ReactNode, SyntheticEvent } from 'react';
import { XIcon } from '@zep/icons';
import { cn } from '../../utils/tailwind';
import { IconContainer } from '../IconContainer';
import S from './Dialog.module.scss';
export const DialogHeader = (props: PropsWithChildren<DialogHeaderProps>) => {
  const {
    className,
    topSlot,
    leftSlot,
    rightSlot,
    closeAriaLabel = 'Close',
    onClose,
    children
  } = props;
  const handleClose = (e: SyntheticEvent) => {
    onClose && onClose(e);
  };
  return <header className={cn(S.header, className)} data-sentry-component="DialogHeader" data-sentry-source-file="DialogHeader.tsx">
      {topSlot && <span className={cn(S.col, S.topSlot)}>{topSlot}</span>}
      <div className={S.col}>
        {leftSlot && <div className={cn(S.slot, S.leftSlot)}>{leftSlot}</div>}
        <div className={cn(S.slot, S.title)}>{children}</div>
        {(rightSlot || onClose) && <div className={cn(S.slot, S.rightSlot)}>
            {rightSlot && rightSlot}
            {onClose && <IconContainer type="button" onClick={handleClose} className={S.close}>
                <XIcon width={20} height={20} aria-label={closeAriaLabel} />
              </IconContainer>}
          </div>}
      </div>
    </header>;
};
type DialogHeaderProps = {
  topSlot?: ReactNode;
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
  className?: string;
  closeAriaLabel?: string;
  onClose?: (e: SyntheticEvent) => void;
};